// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1OnnA","header":"ReportDetails_header__n3qvH","title":"ReportDetails_title__2AWhk","left":"ReportDetails_left__1zQ9c"};